<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-fussion" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<div class="container">
    <div class="common signupformsection">				
        <div class="signupform newTerms">
            <div class="logodiv text-center">
                <a href="#" routerLink="/dashboard"><img src="assets/images/logo.png"></a>
            </div>
            <div class="common signuphdng">
                <div name="termly-embed" data-id="29fa8205-7f90-4a6b-afdc-a6761a0f7720" data-type="iframe"></div>
            </div>

        </div>
    </div>
</div>